 
   (function () {
  function pad2(n){ return String(n).padStart(2,'0'); }
  function nextEvergreenTarget(periodHours){
    var now = new Date();
    var ms = periodHours * 3600 * 1000;
    return new Date(Math.ceil(now.getTime()/ms)*ms);
  }
  function parseEnd(dtStr){
    if(!dtStr) return null;
    // 兼容 iOS：把 2024-12-20 00:00 转为 2024/12/20 00:00
    return new Date(dtStr.replace(/-/g,'/'));
  }

  function initCountdown(el){
    var mode   = el.dataset.mode || 'evergreen';          // 'evergreen' | 'fixed'
    var period = parseInt(el.dataset.periodHours || '2', 10);
    var target = (mode === 'evergreen')
      ? nextEvergreenTarget(period)
      : parseEnd(el.dataset.end);

    // 若时间无效，直接隐藏
    if(mode !== 'evergreen' && (!target || isNaN(target.getTime()))){
      el.classList.add('is-done'); return;
    }

    function finish(){
      el.classList.add('is-done');           // 交给 CSS 隐藏
      el.setAttribute('aria-hidden','true');
    }

    function update(){
      var now  = new Date();
      var diff = target - now;

      if (diff <= 0){
        if (mode === 'evergreen'){
          target = nextEvergreenTarget(period);   // 常绿：重置到下个整周期
          diff   = target - now;
        } else {
          clearInterval(timer);                   // 固定：结束后隐藏
          finish();
          return;
        }
      }

      var d = Math.floor(diff/86400000);
      var h = Math.floor((diff%86400000)/3600000);
      var m = Math.floor((diff%3600000)/60000);
      var s = Math.floor((diff%60000)/1000);

      var q = function(sel){ return el.querySelector(sel); };
      q('[data-cd="days"]').textContent    = pad2(d);
      q('[data-cd="hours"]').textContent   = pad2(h);
      q('[data-cd="minutes"]').textContent = pad2(m);
      q('[data-cd="seconds"]').textContent = pad2(s);
    }

    update();
    var timer = setInterval(update, 1000);
  }

  function boot(){
    document.querySelectorAll('.community-countdown').forEach(initCountdown);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
